<template>
  <div class="ar-box">
    <el-tree
      :data="dataList"
      node-key="id"
      empty-text="点击关联课件按钮批量选择课件吧"
      default-expand-all
      :allow-drop="allowDrop"
      @node-drag-end="handleDragEnd"
      :draggable="$route.query.type != 'check'"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <div class="tree-drag-group">
          <span style="width: 60px; text-align: left;display: inline-block;">
            <span class="level" style="margin-right: 10px;display: inline-block;">{{currentNumber(node, data)}}</span>
          </span>
          <span :title="data.dataName" class="ar-ellipsis" style="margin-right: 3px;width: 500px;">{{data.dataName}}</span>
          <span v-if="type === '2'">
            <el-select v-model="data.dataType" placeholder="请选择课件类型" clearable :popper-append-to-body="false">
              <el-option label="课件" value="课件"></el-option>
              <el-option label="试卷" value="试卷"></el-option>
            </el-select>
          </span>
          <span v-if="type === '2'">
            <el-select v-model="data.paperId" placeholder="请选择试卷" clearable :popper-append-to-body="false">
              <el-option :label="item.questionsPaperName" :value="item.id" v-for="(item,index) in paperList" :key="index"></el-option>
            </el-select>
          </span>
          <span  class="tree-btn-box">
            <el-button v-if="$route.query.type != 'check'" style="padding: 7px 10px;" @click="() => remove(node, data)">移除</el-button>

              <el-button  style="padding: 7px 10px;" @click="() => detail(node, data)">详情</el-button>
          </span>
          <span>&nbsp;&nbsp;反馈:
            <el-select v-model="data.feedbackType" placeholder="请选择反馈类型" clearable :popper-append-to-body="false">
              <el-option label="全部" value="全部"></el-option>
              <el-option label="BA" value="BA"></el-option>
              <el-option label="培训师" value="培训师"></el-option>
            </el-select>
          </span>
        </div>
      </span>
    </el-tree>


    <video-list ref="videoList" ></video-list>
  </div>
</template>

<script>
import  API from '@/api/mall/training.js'
import newAPI from "@/api/new/training.js";
import VideoList from '@/components/training/videoList.vue'
import exam from "@/api/new/exam.js";

export default {
  components: { VideoList},
  name: "associateResource",
  data() {
    return {
      dataList: [],
      defaultProps: {
        children: 'children',
        label: 'dataName'
      },
      type:undefined,
      paperList: []
    }

  },
  mounted() {
    this.getPaperList();
  },
  methods: {
    detail(node, data){
      console.log(this.type)
      // console.log(this.type ==="1")
      // console.log(this.type ==="2")
      if(this.type ==="1"){
        API.getDataDetail({dataId:data.id}).then(res =>{
          // console.log(res)
          // console.log( )
          this.$nextTick(() => {
            this.$refs.videoList.videoShow(res.data)
          })
        })
      }else if (this.type ==="2"){
        newAPI.getDataDetail({dataId:data.id}).then(res =>{
          // console.log(res)
          // console.log( )
          this.$nextTick(() => {
            this.$refs.videoList.videoShow(res.data)
          })
        })
      }

    },
    allowDrop(draggingNode, dropNode, type) {
      if (type != 'inner') {
        return true;
      }
      return false;
    },
    handleDragEnd() {

    },
    currentNumber(node, data){
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      return index + 1;
    },
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      children.splice(index, 1);
    },
    setDataList(dataList,type) {
      console.log("------type----------")
      console.log(type)
      this.type=type;
      this.dataList = dataList;
      if (this.dataList) {
        this.dataList.forEach(obj => {
          if (!obj.id) {
            obj.id = obj.trainingResourcesDataId;
          }
        })
      }
      console.log('datalist-->', this.dataList);
    },
    getPaperList() {
      let p = {
        page: 1,
        pageSize: 2000,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      exam.getPaperList(p).then((res) => {
        this.paperList = res.data.records;
      });
    },
  }
}
</script>

<style>
  .ar-box .tree-drag-group {
    display: flex;
    align-items: center;
    font-size: 14px;
  }

  .ar-box .el-tree-node__content {
    height: 36px;
    margin-bottom: 15px;
  }

  .ar-box .ar-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }

  .ar-box .tree-btn-box {
    margin-left: 15px;
  }

  .ar-box .level {
    padding: 3px;
    border-radius: 6px;
    color: #333;
    background-color: #e0f2ff;
    min-width: 20px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/training/associateResource.vue